module.exports = __webpack_public_path__ + "img/logo-main.48ff4982.png";